import type { App } from "vue";
import Pinia from "./pinia";
import PrimeVue from "./primevue";
import SentryPlugin from "./sentry";
interface PluginOptions {
    primevue?: any;
    pinia?: any;
    sentry?: any;
}

export default {
    install(app: App, options: PluginOptions = {}): void {
        app.use(Pinia, options.pinia);
        app.use(PrimeVue, options.primevue);
        app.use(SentryPlugin, options.sentry);
    },
};
